import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { forwardRef } from "react";
const SvgChevronDown = (props, ref) => /* @__PURE__ */ React.createElement(Svg, { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", ref, ...props }, /* @__PURE__ */ React.createElement(Path, { d: "M6 9l6 6 6-6" }));
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
